import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	letalkPhone: {
		color: colors.purple[600],
		fontSize: "22px"
	},
	container: {
		width: "100%",
		display: "flex",
		flexFlow: "column"
	},
	// Remove this style after Samu tests are done
	whatsappButton: {
		...ColorUtil.getBackgroundAndContrastColor(colors.green[700]),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.green[500])
		}
	},
	portlet: {
		marginTop: "auto",
		marginBottom: "auto"
	},
	logo: {
		display: "block",
		margin: "0 auto",
		maxWidth: "120px",
		height: "auto"
	}
})

export default useStyles
